
export default class fancyBoxAccessibility {
    constructor() {
        let $fancyBoxContainer = () => $('.fancybox-container').length ? $('.fancybox-container') : null;
        let injectButton = `
            <button style="position: absolute; left: -2000px;" class="injected-button-js">Close video and return to website</button>
        `;

        $('.fancybox-js').fancybox({
            afterShow: function () {
                // hide sibling elements, this tells the screen reader that the fancybox container and children the
                // only thing on the page
                $fancyBoxContainer().siblings().attr('aria-hidden', 'true');
                $fancyBoxContainer().find('iframe').attr('title', 'Embedded youtube video');

                // if the Iframe is the last tabbable item, then the user will tab to the last item within the iframe,
                // and then tab out of the window on the next tab-press.  So inject a tabbable element here:
                $(injectButton).insertAfter($fancyBoxContainer().find('.fancybox-content'));
                $('.injected-button-js').click(() => {
                    $('[data-fancybox-close]').trigger('click');
                });
            },
            beforeClose: function () {
                $fancyBoxContainer().siblings().attr('aria-hidden', 'false');
            }
        });
    }
}
